import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CommonErrorModel } from '../models/CommonErrorModel'
import { ResponseModel } from '../models/ResponseModel'


export interface careerNavigatorState {
    loading: boolean,
    error?: CommonErrorModel,
    requestResponse?: ResponseModel,
}

export const initialState: careerNavigatorState = {
    loading: false,
}

export const submitMobileNumberSlice = createSlice({
    name: 'submitMobileNumber',
    initialState,
    reducers: {
        setLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.loading = payload
        },
        setError: (state, { payload }: PayloadAction<CommonErrorModel | undefined>) => {
            state.error = payload
        },
        setSubmitMobileNumberResponse: (state, { payload }: PayloadAction<ResponseModel | undefined>) => {
            state.requestResponse = payload
        },
        resetSubmitMobileNumberState: (state) => {
            state.loading = false
            state.error = undefined
            state.requestResponse = undefined
        }
    },
})

export const { setLoading, setError, setSubmitMobileNumberResponse, resetSubmitMobileNumberState } = submitMobileNumberSlice.actions
export default submitMobileNumberSlice.reducer